<template>
<form>
  <v-container fluid grid-list-lg >
    <v-card>
      <v-toolbar >
        <v-icon>contact_phone</v-icon>
        <v-toolbar-title class="font-weight-light">&nbsp;Asignación a Estudios</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>

      <div class="text-xs-center">
        <v-progress-linear v-show="loadingProgress" indeterminate></v-progress-linear>      
      </div>
    <v-card-text>
      <v-tabs
        v-model="currentTab">
        <v-tab>
          <v-icon>search</v-icon>
          Selección de casos
        </v-tab>
        <v-tab>
          <v-icon>assignment</v-icon>
          Resultado y Asignación
        </v-tab>
        
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-row dense>
                  <v-col cols="3">
                      <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas"
                          item-text="nombre" item-value="id" label="Empresa:" placeholder="Seleccione una"></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                      <v-autocomplete v-model="filtro.canalVentaId" :items="canalesVenta"
                          item-text="nombre" item-value="id" label="Originadas en:" placeholder="Seleccione un Canal de Venta"></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                    <v-autocomplete v-model="filtro.productoId" :items="listProductos"
                          item-text="descripcion" item-value="id" label="Productos:"></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                      <v-select
                          :items="listPlanes"
                          v-model="filtro.planes"
                          item-text="nombre"
                          item-value="id"
                          label="Planes"
                          multiple>
                          <!-- ABAJO esto es para agregar la opción de select all -->
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @click="togglePlanes"
                          >
                            <v-list-item-action>
                              <v-icon :color="filtro.planes.length > 0 ? 'indigo darken-4' : ''">{{ iconPlanes }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Marcar todos</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <!-- ARRIBA esto es para agregar la opción de select all -->
                        <template v-slot:selection="{ item, index }">
                          
                            <span v-if="index === 0">{{ item.nombre }}</span>
                          
                          <span
                            v-if="index === 1"
                            class="grey--text caption"
                          >&nbsp;(+ {{ filtro.planes.length - 1 }} planes más)</span>
                        </template>
                      </v-select>
                  </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="3">
                    <v-radio-group v-model="filtro.radioFiltroMora" column>
                        <v-radio value="FiltrarVectorAtraso" label="Con Vector Atraso"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols ="1">
                    <v-text-field v-if="filtro.radioFiltroMora == 'FiltrarVectorAtraso'" v-model="filtro.vectorAtrasoDesde" label="Desde"></v-text-field>
                </v-col>
                <v-col cols ="1">
                    <v-text-field v-if="filtro.radioFiltroMora == 'FiltrarVectorAtraso'" v-model="filtro.vectorAtrasoHasta" label="Hasta"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="3">
                    <v-radio-group v-model="filtro.radioFiltroMora" column>
                        <v-radio value="FiltrarInicioMora" label="Con Inicio Mora"></v-radio>
                    </v-radio-group>
                </v-col>

                <v-col cols="5">
                    <app-fecha-desdehasta v-if="filtro.radioFiltroMora == 'FiltrarInicioMora'" 
                                            v-on:desde-changed="filtro.inicioMoraDesde = $event"
                                            v-on:hasta-changed="filtro.inicioMoraHasta = $event">
                    </app-fecha-desdehasta>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols ="3">
                    <v-checkbox v-model="filtro.filtrarFechaUltimoPago" label="Filtrar Fecha Último Pago"></v-checkbox>    
                </v-col>

                <v-col cols = "3">
                  <v-layout>
                        <v-text-field v-if="filtro.filtrarFechaUltimoPago" v-model="filtro.fechaUltimoPagoHasta" label="Anterior a:" type="date" prepend-icon="event"
                            ></v-text-field>
                  </v-layout>
                </v-col>

                <v-col cols ="3">
                    <v-checkbox v-model="filtro.filtrarDeudaEntre" label="Filtrar por Rango Deuda"></v-checkbox>    
                </v-col>

                <v-col cols ="1">
                    <v-text-field v-if="filtro.filtrarDeudaEntre" v-model="filtro.deudaDesde" label="Desde"></v-text-field>
                </v-col>

                <v-col cols ="1">
                    <v-text-field v-if="filtro.filtrarDeudaEntre" v-model="filtro.deudaHasta" label="Hasta"></v-text-field>
                </v-col>
              </v-row>
                
              <v-row dense>
                <v-col cols ="3">
                    <v-checkbox v-model="filtro.excluirAcuerdosAlDia" label="Excluir Casos con Acuerdos al Día"></v-checkbox>    
                </v-col>
                <v-col cols ="3">
                    <v-checkbox v-model="filtro.excluirPromesasPagoNoVencidas" label="Excluir Promesas de Pago No Vencidas"></v-checkbox>    
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="3">
                    <v-radio-group v-model="filtro.situacionAsignacion" column>
                        <v-radio value="-1" label="Traer Sólo Casos Sin Asignar"></v-radio>
                        <v-radio value="1" label="Traer Sólo Casos Asignados a"></v-radio>
                    </v-radio-group>
                </v-col>
              </v-row>
                  
              <v-row>
                <v-col cols="3">
                      <v-autocomplete v-if="filtro.situacionAsignacion == '1'" v-model="filtro.asignadoA" :items="listEstudiosConTodos"
                          item-text="descripcion" item-value="id" label="Estudio:" placeholder="Seleccione uno"></v-autocomplete>
                  </v-col>
                  <v-col cols="5">
                    <app-fecha-desdehasta v-if="filtro.situacionAsignacion == '1'"
                                            v-on:desde-changed="filtro.fechaAsignacionDesde = $event"
                                            v-on:hasta-changed="filtro.fechaAsignacionHasta = $event">
                    </app-fecha-desdehasta>
                  </v-col>
              </v-row>
              
              <v-expansion-panels multiple popout accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header v-slot="{  }">
                        <v-row>
                            <v-col>Importar desde Archivo Excel</v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <v-alert color="warning" dark dense>
                            Al importar casos de un archivo, solo se tendrá en cuenta el filtro de Empresa. 
                            El archivo debe tener formato Excel, con sólo una columna (A) con el Número de Crédito (y con encabezado 'Credito') 
                          </v-alert>
                        </v-col>
                      </v-row>
                        <v-row align="center">
                          <v-col>
                            <v-file-input  
                                v-model="archivoFiltroOperaciones"
                                placeholder="Seleccione el archivo Excel"
                                label="Archivo Filtro"
                                prepend-icon="mdi-paperclip">
                            </v-file-input>
                          </v-col>
                          <v-col>
                            <v-btn @click="traerListaOperacionesDeExcel()">
                              Cargar Archivo
                            </v-btn>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col v-if="archivoFiltroOperaciones != null">
                            <v-chip v-if="operacionesFiltro.id == ''" label color="warning">
                              Presione Cargar Archivo para procesarlo
                            </v-chip>
                            
                            <template v-else>
                              <v-chip  small label color="green" dark >
                                Hay {{operacionesFiltro.cantidad }} Créditos en el Archivo
                              </v-chip>
                              <v-chip  label small color="red" dark v-if="totalItems > 0 && (operacionesFiltro.cantidad - totalItems) > 0">
                                Hay {{operacionesFiltro.cantidad - totalItems  }} Créditos no encontrados
                              </v-chip>
                              
                            </template>
                          </v-col>
                          
                        </v-row>
                        <v-row v-if="operacionesFiltro.cantidad > 0">
          
                          <v-spacer></v-spacer>
                          <v-btn color="success"  @click="importarExcel()">Buscar Casos del Archivo</v-btn>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>

            </v-card-text>
            <v-card-actions>
              <v-btn color="success" @click="getItems()">Realizar Búsqueda</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <!-- resultado y asignación -->
        <v-tab-item>
          <v-card flat>
              <v-data-table dense
                  :headers="headers" 
                  :items="records"
                  v-model="selectedCasos"
                  :loading="loading"                    
                  :show-select="records.length>0"
                  item-key="creditoId"             
                >
                <template v-slot:no-data>
                  <v-alert v-if="!records.length>0" :value="true" color="grey" icon="info">
                    No se encontraron datos
                  </v-alert>
                </template>
              
                <template v-slot:header.data-table-select="{ on, props }">
                    <v-checkbox @change="selectAllChanged" color="purple" v-bind="props" v-on="on"></v-checkbox>
                </template>

                <template v-slot:item="{ item, isSelected, select }">
                    <tr>
                      <td><v-simple-checkbox class="caption" color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox></td>
                      <td  >
                        <v-speed-dial direction="right" :open-on-hover='true' >
                          <template v-slot:activator >
                            <v-btn slot="activator" color="orange" fab text small>
                              <v-icon color="orange" >touch_app</v-icon>                                
                            </v-btn>
                          </template>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="error" v-on="on" @click="verLegajo(item)">
                                <v-icon>person_pin</v-icon>
                              </v-btn>
                            </template>
                            <span>Legajo</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="purple" v-on="on" @click="verCreditos(item)">
                                <v-icon>playlist_add_check</v-icon>
                              </v-btn>
                            </template>
                            <span>Créditos</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="indigo" v-on="on">
                                <v-icon>history</v-icon>
                              </v-btn>
                            </template>
                            <span>Contactos</span>
                          </v-tooltip>
                        </v-speed-dial>
                      </td>

                      <td class="text-xs-left caption">{{ item.canalVentaNombre }}</td>
                      <td class="text-xs-left caption">{{ item.nombreCliente }}</td>
                      <td class="text-xs-left caption">{{ item.documento }}</td>
                      <td class="text-xs-left caption">{{ item.numeroCredito }}</td>
                      <td class="text-xs-left caption">{{ item.deuda | currency }}</td>
                      <td class="text-xs-left caption">{{ item.fechaCaida | dateParse() | dateFormat('DD-MM-YYYY')}}</td>
                      
                      <td class="text-xs-left caption">{{ item.vectorAtraso}}</td>

                      <td class="text-xs-left caption" v-if="item.cantidadCreditos > 1"> <v-chip x-small @click="verOtrosCreditos(item)" color="info" dark>+{{item.cantidadCreditos-1}}</v-chip> </td>
                      <td class="text-xs-left caption" v-else> </td>

                      <td class="text-xs-left caption" v-if="item.hayAvisos">Atencion!</td>
                      <td class="text-xs-left caption" v-else>-</td>

                      <td class="text-xs-left caption">{{ item.estudio  }}</td>
                    </tr>
                  </template>
              </v-data-table>
            </v-card >
            <v-divider></v-divider>
            <v-card flat>
              <v-card-title>
                Asignación de Casos: Hay {{selectedCasos.length}} créditos seleccionados
              </v-card-title>
              <v-card-text>

                <v-row dense>
                  <v-radio-group v-model="asignacionCommand.modoAsignacion" row>
                        <v-radio value="AsignarTodo" label="Asignar Casos"></v-radio>
                        <v-radio value="Desasignar" label="Desasignar"></v-radio>
                  </v-radio-group>
                </v-row>

                <v-row dense v-if="asignacionCommand.modoAsignacion =='AsignarTodo'">
                  <v-col cols="4">
                    <v-autocomplete
                          :items="listEstudios"
                          v-model="asignacionCommand.estudioId"
                          item-text="descripcion"
                          item-value="id"
                          label="Asignar a">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                
                <v-row dense v-if="asignacionCommand.modoAsignacion =='AsignarTodo'">
                  <!-- <v-col v-if="asignacionCommand.modoAsignacion =='AsignarTodo'">
                    <v-checkbox v-model="asignacionCommand.marcaDefinitiva" 
                        label="Realizar Marca"></v-checkbox>    
                  </v-col> -->
                  <v-col v-if="asignacionCommand.modoAsignacion =='AsignarTodo'">
                    <v-checkbox v-model="asignacionCommand.generarExcel" 
                        label="Generar Archivo (Excel)"></v-checkbox>    
                  </v-col>
                  <v-col v-if="asignacionCommand.modoAsignacion =='AsignarTodo'">
                    <v-checkbox v-model="asignacionCommand.generarListado" 
                        label="Listado Respaldatorio"></v-checkbox>    
                  </v-col>
                
                </v-row>

              </v-card-text>
              <v-card-actions>
                <v-btn color="success" @click="procesarCasos()">Procesar Asignación</v-btn>
              </v-card-actions>
            </v-card>
        </v-tab-item>
      </v-tabs>
      </v-card-text>
    </v-card>
    <app-loading :loading="loading"></app-loading>

    <!-- Ver Legajo Cliente  -->
    <v-dialog v-model="showLegajoPersona" width="1000" >
        <legajo-persona :personaId="selectedPersonaId"> </legajo-persona>
    </v-dialog>

    <!-- Ver Detalle de Otros Créditos  -->
    <v-dialog v-model="showOtrosCreditos" width="1000" >
          <v-card flat>
              <v-data-table dense
                  :headers="headersOtrosCreditos" 
                  :items="recordsOtrosCreditos"
                  v-model="selectedCasos"
                  :loading="loading"                    
                  :show-select="recordsOtrosCreditos.length>0"
                  item-key="creditoId"             
                >
                <template v-slot:no-data>
                  <v-alert v-if="!records.length>0" :value="true" color="grey" icon="info">
                    No se encontraron datos
                  </v-alert>
                </template>
              
                <!-- <template v-slot:header.data-table-select="{ on, props }">
                    <v-checkbox @change="selectAllChanged" color="purple" v-bind="props" v-on="on"></v-checkbox>
                </template> -->

                <template v-slot:item="{ item, isSelected, select }">
                    <tr>
                      <td><v-simple-checkbox class="caption" color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox></td>
                      <td  >
                        <v-speed-dial direction="right" :open-on-hover='true' >
                          <template v-slot:activator >
                            <v-btn slot="activator" color="orange" fab text small>
                              <v-icon color="orange" >touch_app</v-icon>                                
                            </v-btn>
                          </template>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="error" v-on="on" @click="verLegajo(item)">
                                <v-icon>person_pin</v-icon>
                              </v-btn>
                            </template>
                            <span>Legajo</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="purple" v-on="on" @click="verCreditos(item)">
                                <v-icon>playlist_add_check</v-icon>
                              </v-btn>
                            </template>
                            <span>Créditos</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="indigo" v-on="on">
                                <v-icon>history</v-icon>
                              </v-btn>
                            </template>
                            <span>Contactos</span>
                          </v-tooltip>
                        </v-speed-dial>
                      </td>

                      <td class="text-xs-left caption">{{ item.canalVentaNombre }}</td>
                      <td class="text-xs-left caption">{{ item.numeroCredito }}</td>
                      <td class="text-xs-left caption">{{ item.deuda | currency }}</td>
                      <td class="text-xs-left caption">{{ item.fechaCaida | dateParse() | dateFormat('DD-MM-YYYY')}}</td>
                      
                      <td class="text-xs-left caption">{{ item.vectorAtraso}}</td>

                      <td class="text-xs-left caption" v-if="item.hayAvisos">Atencion!</td>
                      <td class="text-xs-left caption" v-else>-</td>

                      <td class="text-xs-left caption">{{ item.estudio  }}</td>
                    </tr>
                  </template>
              </v-data-table>              
          </v-card>
    </v-dialog>

  </v-container>

  <template v-if="$store.state.debugModeOn && (this.currentTab === 0)" >
    Debug Info: <p></p>
    
    Filtro: {{filtro}}  <p></p>
    
  </template>
  <template v-if="$store.state.debugModeOn && (this.currentTab === 1)" >
    Debug Info: <p></p>
    
    AsignacionCommand: {{asignacionCommand}}  <p></p>
    
  </template>
</form>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'
import { ValidationObserver, ValidationProvider} from "vee-validate";

import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'
import { format } from 'date-fns'
import LegajoPersona from '@/components/legajo/layout.vue'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    'legajo-persona': LegajoPersona
  },
  data () {
    return {
      currentTab:null,
      loading: false,
      loadingProgress: false, // Lo uso para la progress bar
      editMode: true,
      headers: [ // definición de columnas
        { text: 'Ver', value: 'accion', width:80, sortable:false },
        { text: 'Canal de Venta', value: 'canalVentaNombre'},
        { text: 'Deudor', value: 'nombreCliente'},
        { text: 'Documento', value: 'documento'},
        { text: 'No. Crédito', value: 'numeroCredito'},
        { text: 'Deuda', value: 'deuda',width: 130},
        { text: '1er Cta. Imp.', value: 'fechaCaida',width:130},
        { text: 'V.A.', value: 'vectorAtraso',width:100},
        { text: 'Otros Créditos', value: 'cantidadCreditos',width:100},
        { text: '', value: 'hayAvisos',width:100},
        { text: 'En Estudio', value: 'estudio'}
      ],
      headersOtrosCreditos: [ // definición de columnas
        { text: 'Ver', value: 'accion', width:80, sortable:false },
        { text: 'Canal de Venta', value: 'canalVentaNombre'},
        { text: 'No. Crédito', value: 'numeroCredito'},
        { text: 'Deuda', value: 'deuda',width: 130},
        { text: '1er Cta. Imp.', value: 'fechaCaida',width:130},
        { text: 'V.A.', value: 'vectorAtraso',width:100},
        { text: 'En Estudio', value: 'estudio'}
      ],
      records: [], // registros
      totalItems: 0,
      selectedCasos:[],
      selectedCreditoId: null,
      filtro:{empresaId:1, productoId:0, canalVentaId:0,planes:[], radioFiltroMora:'FiltrarVectorAtraso',vectorAtrasoDesde:0,vectorAtrasoHasta:0,inicioMoraDesde:format(new Date(),'YYYY-MM-DD'),inicioMoraHasta:format(new Date(),'YYYY-MM-DD'),
              filtrarFechaUltimoPago:false,fechaUltimoPagoHasta:format(new Date(),'YYYY-MM-DD'),filtrarDeuda:false,deudaDesde:0,deudaHasta:0,
              excluirAcuerdosAlDia:true,excluirPromesasPagoNoVencidas:true,
              situacionAsignacion:'-1',fechaAsignacionDesde:format(new Date(),'YYYY-MM-DD'),fechaAsignacionHasta:format(new Date(),'YYYY-MM-DD'),
              generarExcel: false, generarListado: false},
      listEmpresas: [],      
      canalesVenta: [],
      listProductos: [],
      listPlanes: [],
      listEstudios: [],
      asignacionCommand:{creditosId:[],modoAsignacion:'AsignarTodo',fechaInicioGestion:format(new Date(),'YYYY-MM-DD'),cerrarGestionesAnteriores:false},
      showLegajoPersona: false,
      selectedPersonaId: '',
      showOtrosCreditos: false,
      archivoFiltroOperaciones: null,
      operacionesFiltro: {id: '', cantidad:0}
    }
  },
  async created() {
      this.loadProductos();
      this.loadPlanes();
      this.loadCanalesVentaYEmpresas();
      this.loadEstudios();
  },
  watch:{
    'filtro.empresaId'(){
      this.loadPlanes();
    },
  },
  computed:{
    ...mapGetters(['user', 'UiCustomUserSettings', 'DebugModeOn', 'getActionFromLink']),
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
    listEstudiosConTodos:function(){
      let listEstudiosConTodos = Array.from(this.listEstudios);
      listEstudiosConTodos.unshift({id:"0",descripcion:'(Todos)'})
      return listEstudiosConTodos;
    },
    todosLosPlanesMarcados () {
      return this.filtro.planes.length === this.listPlanes.length
    },
    algunosPlanesMarcados () {
      return this.filtro.planes.length > 0 && !this.todosLosPlanesMarcados
    },
    iconPlanes () {
      if (this.todosLosPlanesMarcados) return 'mdi-close-box'
      if (this.algunosPlanesMarcados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectedEmpresa: function(){
      if(this.filtro.empresaId && this.fltro.empresaId > 0)
        return this.listEmpresas.find(i=> i.id === this.filtro.empresaId)

      return null
    },
    selectedCanalVenta: function(){
      if(this.filtro.canalVentaId && this.filtro.canalVentaId > 0)
        return this.canalesVenta.find(i=> i.id === this.filtro.canalVentaId)

      return null
    },
    recordsOtrosCreditos: function(){
        if(this.selectedCreditoId == null || this.records.length == 0) return [];
        return this.records.find(i=>i.creditoId == this.selectedCreditoId).otrosCreditos;
    }
  },
  methods:{
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    togglePlanes(){
        this.$nextTick(() => {
          if (this.todosLosPlanesMarcados) {
            this.filtro.planes = []
          } else {
            this.filtro.planes = this.listPlanes.map(function(p) {return p.id;});
          }
        })
    },
    verOtrosCreditos(item){
        this.selectedCreditoId = item.creditoId;
        this.showOtrosCreditos = true;
    },
    async loadProductos(){
      this.loading = true;
      try{
        var result = await http.get('productos/');        

        this.listProductos = result.list;

        this.listProductos.unshift({id:0,descripcion:'(Todos)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadPlanes() {
        this.loading = true
        try {
            var result = await http.get('planes?empresaId=' + this.filtro.empresaId); // traigo todos
            this.listPlanes = result.list;            

            this.togglePlanes();//agrego esto para que por defecto estén todos marcados
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async cancelar(){
      const res = await this.$dialog.confirm({
                text: '¿Confirmar la cancelación de la carga?',
                title: 'Atención',
                persistent: true // Parece que no funciona...
              })

      if (!res) {
        return;
      }
      else{
        this.clear()
      }
    },
    async clear(){
      
    },
    async loadCanalesVentaYEmpresas() {
        this.loading = true
        try {
            var result = await http.get('canalesventa/habilitadosparausuario?usuarioId='+ this.user.id ); // traigo todas
            this.canalesVenta = result.list;

            // extraigo las empresas de los canales habilitados
            this.listEmpresas = Array.from(new Set(this.canalesVenta.map(i=>i.empresaId)))
            .map(id => {
              return {
                id: id,
                nombre: this.canalesVenta.find(s=>s.empresaId === id).empresaDescripcion
              }
            })
          
          // selecciono la empresa predefinida del usuario
          if(this.UiCustomUserSettings.empresaPredeterminadaId > 0){
            if(this.listEmpresas.find(i=> i.id === this.UiCustomUserSettings.empresaPredeterminadaId)){
              this.filtro.empresaId = this.UiCustomUserSettings.empresaPredeterminadaId
            }
          }

          // selecciono el canal de venta predefinido del usuario
          if(this.UiCustomUserSettings.canalVentaPredeterminadoId > 0){
            if(this.canalesVenta.find(i=> i.id === this.UiCustomUserSettings.canalVentaPredeterminadoId)){
              this.filtro.canalVentaId = this.UiCustomUserSettings.canalVentaPredeterminadoId
            }
          }

          this.canalesVenta.unshift({id:0,nombre:'(Todos)'});
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadEstudios(){
      this.loading = true;
      try{
        var result = await http.get('estudiosexternos');//traigo los estudios

        this.listEstudios = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async getItems() {
      Vue.$log.debug(this.filtro)

      if(!this.validarFiltros()) return;
      
      this.loading = true
      this.$validator.reset()
      
      let filter = this.filtro;

      let idCanalesVenta = filter.canalVentaId.toString();
      
      //Si se eligió TODOS ( y no tiene acceso a todos los canales) armo un string con todos los canales de venta habilitados para el usuario.
      if(filter.canalVentaId === 0 )
      {
        if( !this.$store.state.user.accesoTodosCanalesVenta){
          for(var i = 1; i< this.canalesVenta.length;i++ )
          {
            if(i === 1)
            idCanalesVenta = this.canalesVenta[i].id;
            else
            idCanalesVenta += "," + this.canalesVenta[i].id;
          }
        }
        else{
          idCanalesVenta = "0";
        }
      }

      const filtrarVectorAtraso = filter.radioFiltroMora == 'FiltrarVectorAtraso';
      const filtrarInicioMora = !filtrarVectorAtraso;
      
      if(filter.situacionAsignacion == -1)
        filter.asignadoA = null;
      else
        if(filter.asignadoA == '(Todos)')
            filter.asignadoA = '0';


      try {
        var result = await http.get('gestion/getcasosparaasignacionaestudio?empresaId='+filter.empresaId + '&canalesVenta='+idCanalesVenta + '&productoId=' + filter.productoId + '&planes=' + filter.planes
                      + '&filtrarVectorAtraso='+filtrarVectorAtraso+ '&vectorAtrasoDesde='+filter.vectorAtrasoDesde + '&vectorAtrasoHasta=' + filter.vectorAtrasoHasta 
                      + '&filtrarInicioMora='+filtrarInicioMora + '&inicioMoraDesde=' + filter.inicioMoraDesde  + '&inicioMoraHasta=' + filter.inicioMoraHasta
                      + '&filtrarFechaUltimoPago='+filter.filtrarFechaUltimoPago + '&fechaUltimoPagoHasta=' + filter.fechaUltimoPagoHasta
                      + '&filtrarDeuda='+filter.filtrarDeuda + '&deudaDesde=' + filter.deudaDesde + '&deudaHasta=' + filter.deudaHasta
                      + '&excluirCasosConAcuerdosAlDia=' + filter.excluirAcuerdosAlDia + '&excluirPromesasPagoNoVencidas=' + filter.excluirPromesasPagoNoVencidas
                      + '&situacionAsignacion='+filter.situacionAsignacion+'&fechaAsignacionDesde='+filter.fechaAsignacionDesde + '&fechaAsignacionHasta=' + filter.fechaAsignacionHasta 
                      + '&asignadoA=' + filter.asignadoA);

        Vue.$log.debug(result);
        
        this.records = result.list;
        this.totalItems = result.totalCount

        this.selectedCasos = [];
        this.currentTab = 1;
        
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async procesarCasos()
    {
      if(!this.validarComandoAsignacion()) return;

      this.loading = true;

      this.asignacionCommand.empresaId = this.filtro.empresaId;
      this.asignacionCommand.creditosId = this.selectedCasos.map(c => c.creditoId);
      
      if(this.asignacionCommand.modoAsignacion != 'Desasignar')
      {
        this.asignacionCommand.estudioId = this.asignacionCommand.estudioId;
      }
      // else{
      //   this.asignacionCommand.marcaDefinitiva = true;
      // }

      Vue.$log.debug(this.asignacionCommand);

      try{
        
        var result = await http.post('gestion/asignaraestudio', JSON.stringify( {asignacion:  this.asignacionCommand} ) );

        this.alertSuccess('Se han asignado los casos correctamente. Se limpiará la lista.')
        if(this.asignacionCommand.generarExcel){
        }

        if(this.asignacionCommand.generarListado){
        }

        this.records = [];        
        this.selectedCasos = [];

      } 
      catch(error){
        Vue.$log.error(error);
        // Error
        this.alertError(error)
      }            

      this.loading=false;
    },
    validarFiltros()
    {
      if(this.filtro.radioFiltroMora == 'FiltrarVectorAtraso')
      {
        if(isNaN(this.filtro.vectorAtrasoDesde) || isNaN(this.filtro.vectorAtrasoHasta))
        {
          this.alertWarning('El valor del filtro de Vector Atraso es incorrecto.');
          return false;
        }
      }

      return true;
    },
    validarComandoAsignacion()
    {
        if(!this.selectedCasos.length > 0)
        {
          this.alertWarning('Debe elegir algún caso para asignar.');
          return false;
        }
        if(this.asignacionCommand.modoAsignacion != 'Desasignar')
        {
          if(!(this.asignacionCommand.estudioId > 0))
          {
            this.alertWarning('Debe elegir el Estudio al cual asignar los casos.');
            return false;
          }
        }
        
        return true;
    },
    changeTab()
    {
      this.currentTab = 1;
    },
    async verLegajo(item){
      this.selectedPersonaId = item.personaId;
      this.showLegajoPersona = true;
    },
    async verCreditos(item){
      this.selectedPersonaId = item.personaId;
      
      var params = {
          width:900,
          visible: true,
          personaId: item.personaId
      };

      this.setActiveTask({task:'app-lista-creditos', props: params})
    },
    selectAllChanged(toggle){
      this.selectedCasos = []
      if(toggle){
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];
          
          this.selectedCasos.push(element)

          // agrego los "otros créditos"
          for (let j = 0; j < element.otrosCreditos.length; j++) {
              const otroCredito = element.otrosCreditos[j];
              this.selectedCasos.push(otroCredito);
              
          }   
        }
      }
    },
    async traerListaOperacionesDeExcel(){

      if(!this.archivoFiltroOperaciones) return;
      if(!this.archivoFiltroOperaciones.name.includes('.xls'))
      {
        this.archivoFiltroOperaciones = [];
        this.alertWarning('Debe elegir un archivo Excel.');
        return;
      }

      this.loading = true;
      let formData = new FormData();  

      formData.append('archivo',this.archivoFiltroOperaciones);

      try{
        var listaOps = await http.post('archivosDebito/excelAFiltroOperaciones', formData);
        this.operacionesFiltro = listaOps;
      } catch (error) {
          // Error
          this.alertError(error)
      }
      
      this.loading = false;

    },
    async importarExcel(){

      this.loading = true;
      try {
        var result = await http.get('gestion/getcasosparaasignacionaestudioporlistacreditos?empresaId='+this.filtro.empresaId + '&filtroId='+ this.operacionesFiltro.id);

        Vue.$log.debug(result);
        
        this.records = result.list;
        this.totalItems = result.totalCount

        if(result.totalCount != this.operacionesFiltro.cantidad){
          var diff = this.operacionesFiltro.cantidad - result.totalCount;
          this.alertWarning('Hay ' + diff + ' casos de diferencia entre los del archivo y los encontrados en condiciones de asignar.')
        }

        this.selectedCasos = [];
        this.currentTab = 1;
        
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false

    }
  }
}
</script>
